import { create } from 'zustand'

const useStore = create((set) => {
    return {
        decorationTypeList: null,
        decorationPortraitList: [],
        bookingData: null,
    
        setDecorationTypeList: (decorationTypeList) => set({ decorationTypeList }),
        setDecorationPortraitList: (decorationPortraitList) => set({ decorationPortraitList }),
        setBookingData: (bookingData) => set({ bookingData }),
    }
})
export default useStore